module.exports = function() {
	return new Worker(__webpack_public_path__ + "af736b6e73dc26646178.worker.js");
};


/*****************
 ** WEBPACK FOOTER
 ** ./scripts/workers/sway.worker.js
 ** module id = 383
 ** module chunks = 0
 **/